import * as THREE from 'three';

export function createInfoCard(scene, material, positionX, positionY, positionZ, absScale, name, infoCards, cardIndex) {
    const infoCard = new THREE.Sprite(material);
    infoCard.userData.name = name;
    infoCard.position.set(positionX, positionY, positionZ);
    infoCard.scale.set(absScale, absScale, absScale);
    infoCard.visible = false;

    scene.add(infoCard);
    infoCards[cardIndex] = infoCard;
};